/* eslint-disable no-underscore-dangle */
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';

import { COUNTRY_LIST, SALUTATION, VALIDATORS } from 'app/constants';
import { ContactPerson } from 'graphql/models/generated';
import { BaseComponent } from 'shared/base/base.component';
import { PermissionsService } from 'shared/services/permissions.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-contact-person-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss']
})
export class ContactPersonBasicInfoComponent extends BaseComponent implements OnInit {
  @Input() canAutoSave = true;

  contactPersonId: string | undefined;

  dropdownData = {
    countries: COUNTRY_LIST,
    salutation: SALUTATION
  };

  form!: UntypedFormGroup;

  formReady = false;

  get addressForm(): UntypedFormGroup {
    return this.form.controls.address as UntypedFormGroup;
  }

  constructor(
    protected fb: UntypedFormBuilder,
    private storeService: StoreService,
    private permissionsService: PermissionsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.storeService.getCurrentContactPerson()
      .pipe(take(1))
      .subscribe((data: ContactPerson) => {
        const contact = data || {};

        this.form = this.fb.group({
          salutation: [contact.salutation || null, [Validators.required]],
          firstName: [contact.firstName || '', [
            Validators.required, Validators.maxLength(VALIDATORS.MAX_LENGTH.INPUT_SHORT)]],
          lastName: [contact.lastName || '', [
            Validators.required, Validators.maxLength(VALIDATORS.MAX_LENGTH.INPUT_SHORT)]],
          email: [contact.email || '', [Validators.pattern(VALIDATORS.PATTERN.MAIL)]],
          phone: [contact.phone || '', [Validators.pattern(VALIDATORS.PATTERN.PHONE)]],
          mobile: [contact.mobile || '', [Validators.pattern(VALIDATORS.PATTERN.PHONE)]],
          fax: [contact.fax || '', [Validators.pattern(VALIDATORS.PATTERN.FAX)]]
        }, { updateOn: 'blur' });

        if (this.permissionsService.cannotUpdateContactPerson()) {
          this.form.disable({ emitEvent: false });
        }

        this.formReady = true;
        this.storeService.setFormReady(this.formReady);
      });
  }
}
